import axios from 'axios'
import {getApiUrls} from "@/http/base.http";

export function ddReportHub() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/report/hub/dd`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function ddReportSensorType() {
    const { env } = getApiUrls();
    return axios.get(`${env}dropdown/report/sensor/type/dd`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function ddReportComponent(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}dropdown/report/component/dd`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function ddReportSensor(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}dropdown/report/sensor/dd`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function ddSubmitId(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}dropdown/client/dd`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function generateReportData(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}generate/report/get`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
export function getReportData(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}report/get`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function DownloadSensorReportData(payload) {
    const { env } = getApiUrls();
    return axios.post(`${env}sensor/report/download`, payload, {
    responseType: 'blob'
  }).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

